import parseValueForType from "components/ProjectNonSpecificComponents/Functions/parseValueForType"
import { IRequestTableData } from "../Interfaces/DataInterface"
import formatFullDate from "./formatFullDate"

/**
 * Takes records from back end
 * Parses them for FE table
 */
const parseRecordsForTable = (records: IRequestTableData[], head: any): any[] => {
	const _records = new Array()

	records?.map(({ fields }) => {
		const _record: any = {}

		fields.map(({ fieldId, value, color }) => {	
			_record[fieldId] = parseValueForType(value, head[fieldId]?.type)

			/**
			 * Some fields come with color to display
			 * If field has color, then add additional property containing color code
			 */
			if (color) {
				_record[`${fieldId}-color`] = color
			}
		})

		_records.push(_record)
	})

	return _records
}

export default parseRecordsForTable
